<template>
    <tr>
        <td>{{ row.full_name }}</td>
        <td>{{ row.id }}</td>
        <td>{{ row.external_id }}</td>
        <td>{{ row.external_username }}</td>
        <td>
            <i v-if="row.active" class="fa fa-check-circle mr-2 text-primary" aria-hidden="true" title="Activo"></i>
            <i v-else class="fa fa-times mr-2 text-danger" aria-hidden="true" title="No activo"></i>
        </td>
    </tr>
</template>


<script>
export default {
    componenents: {},
    props: {
        row: {
            type: Object,
            required: true
        }
    }
}
</script>
